import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';

@Component({
  selector: 'prv-next-buttons',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './prv-next-buttons.component.html',
  styleUrl: './prv-next-buttons.component.css' // optional, or remove this line
})
export class PrvNextButtonsComponent implements OnInit {
  @Input() totalPages: { title: string; route: string }[] = [];

  icons = Icons;
  currentRoute: string = '';
  currentIndex: number = -1;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Recompute on route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateCurrentIndex());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalPages']) {
      this.updateCurrentIndex();
    }
  }

  private updateCurrentIndex(): void { 
    const cleanUrl = this.router.url
      .replace(/^\/+/, '')
      .split('?')[0]
      .split('#')[0]
      .toLowerCase();

    this.currentRoute = cleanUrl; 
    
    if (this.totalPages?.length) { 
      this.currentIndex = this.totalPages.findIndex( p => 
        p.route.toLowerCase().replace(/^\/+/, '') === cleanUrl 
      ); 
    } 
  }

  hasPrevious(): boolean {
    return this.currentIndex > 0;
  }

  hasNext(): boolean {
    return this.currentIndex >= 0 && this.currentIndex < this.totalPages.length - 1;
  }

  goToPrevious(): void {
    if (this.hasPrevious()) {
      this.router.navigateByUrl('/' + this.totalPages[this.currentIndex - 1].route);
    }
  }

  goToNext(): void {
    if (this.hasNext()) {
      this.router.navigateByUrl('/' + this.totalPages[this.currentIndex + 1].route);
    }
  }
}
